module.exports = __webpack_public_path__ + "img/FK.4e9526a8.svg";